import { render, staticRenderFns } from "./detail-catalog.vue?vue&type=template&id=0cb0cb91&scoped=true&"
import script from "./detail-catalog.vue?vue&type=script&lang=js&"
export * from "./detail-catalog.vue?vue&type=script&lang=js&"
import style0 from "./detail-catalog.vue?vue&type=style&index=0&id=0cb0cb91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb0cb91",
  null
  
)

export default component.exports